








































































































































































































































import { Component, Vue } from 'vue-property-decorator';

import axios from 'axios';

import { Company, DataFilter, UserRoleName } from '@/lib/models';

@Component
export default class Companies extends Vue {
  private hasTraceAdminRole: boolean = this.hasUserRole(UserRoleName.TraceAdmin);
  private hasSupportAccessRole: boolean = this.hasUserRole(UserRoleName.SupportAccess);

  private isLoading: boolean = false;
  private currentPage: number = 1;
  private totalRows: number = 0;
  private pageOptions: number[] = [5, 10, 15, 20];
  private perPage: number = 10;

  private companyFields: any[] = [
    {
      key: 'name',
      sortable: true,
    },
    {
      key: 'industry.name',
      label: 'Industry',
      sortable: false, // not implemented on backend
    },
    {
      key: 'city',
      sortable: true,
    },
    {
      key: 'geographicalRegion',
      label: 'State',
      sortable: false, // not implemented on backend
    },
    {
      key: 'actions',
      sortable: false,
    },
  ];

  private readonly activeOptions: string[] = ['active', 'inactive', 'all'];
  private industryOptions: any[] = [];
  private applicationModuleOptions: any[] = [];

  private get actualCompanyId(): string {
    return (this as any).$auth0.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/app_metadata']['company_id'];
  }

  private get supportAccessCompanyId(): string {
    return (this as any).$auth0.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/app_metadata']['support_access_company_id'];
  }

  private get currentCompanyId(): string {
    if (this.supportAccessIsEnabled) {
      return this.supportAccessCompanyId;
    } else {
      return this.actualCompanyId;
    }
  }

  private companyFilter: any = {
    active: 'active',
    name: '',
    industry: '',
    city: '',
    applicationModule: '',
  };

  private hasUserRole(name: UserRoleName): boolean {
    return (this as any).$auth0.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/roles'].includes(name);
  }

  private async companyProvider(context: any): Promise<Company[]> {
    let url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/companies?limit=${context.perPage}&page=${context.currentPage}`;

    if (context.sortBy !== '') {
      url += `&sort=${context.sortBy}:${context.sortDesc ? 'desc' : 'asc'}`;
    }

    if (context.filter.active !== '') {
      if (context.filter.active === 'active') {
        url += '&active=true';
      } else if (context.filter.active === 'inactive') {
        url += '&active=false';
      }
    }

    if (context.filter.name !== '') {
      url += `&name=${encodeURIComponent(context.filter.name)}`;
    }

    if (context.filter.industry !== '') {
      url += `&industry=${encodeURIComponent(context.filter.industry)}`;
    }

    if (context.filter.city !== '') {
      url += `&city=${encodeURIComponent(context.filter.city)}`;
    }

    if (context.filter.applicationModule !== '') {
      url += `&applicationModule=${encodeURIComponent(context.filter.applicationModule)}`;
    }

    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    this.isLoading = true;
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const companies = response.data.data;
      this.totalRows = response.data.meta.total;

      const dataFilters: DataFilter[] = response.data.meta.dataFilters;

      const applicationModuleFilter = dataFilters.find(((f) => f.name === 'applicationModule'));
      if (applicationModuleFilter !== undefined) {
        this.applicationModuleOptions = applicationModuleFilter.filterOptions.map((o) => {
          return { value: o.value, text: o.key };
        });
        this.applicationModuleOptions.unshift({ value: '', text: '-- none selected --' });
      }

      const industryFilter = dataFilters.find(((f) => f.name === 'industry'));
      if (industryFilter !== undefined) {
        this.industryOptions = industryFilter.filterOptions.map((o) => {
          return { value: o.value, text: o.key };
        });
        this.industryOptions.unshift({ value: '', text: '-- none selected --' });
      }

      return companies || [];
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Getting Companies',
        okVariant: 'danger',
        centered: true,
      }).then(() => {
        return [];
      });
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private get supportAccessIsEnabled(): boolean {
    const appMetadata = (this as any).$auth0.user[process.env.VUE_APP_AUTH0_CUSTOM_CLAIM_NAMESPACE + '/app_metadata'];
    const supportAccessCompanyId = appMetadata['support_access_company_id'];
    return supportAccessCompanyId !== undefined && supportAccessCompanyId !== null;
  }

  private enableSupportAccess(company: Company): void {
    (this as any).$auth0.loginWithRedirect({
      authorizationParams: {
        enableSupportAccess: true,
        supportAccessCompanyId: company.id,
      },
    });
  }
}
